


















import Vue, { PropType } from 'vue';
import _ from 'lodash';

// eslint-disable-next-line no-undef
declare const webkitSpeechRecognition: typeof SpeechRecognition;

export default Vue.extend({
  props: {
    talkTime: {
      type: Object as PropType<{H: string; mm: string}>,
      required: true,
    },
  },
  data() {
    return {
      isRestart: true,
      recognition: null as SpeechRecognition | null,
      poppedTopic: '',
    };
  },
  beforeRouteEnter(to, from, next) {
    if (from.name === null) {
      next('/');
    }
    next();
  },
  created() {
    const topics = [
      '学生生活の１番の思い出はなんですか',
      '旅行に行くならどこに行きたいですか',
      '今週一番楽しかったことは何ですか',
      '休日は何をしていることが多いですか',
      '宝くじに当たったら何がしたいですか',
      '好きな食べ物は何ですか',
      '犬派ですか、猫派ですか',
      '最近映画とかアニメとか見てますか',
      '最近買ったもので何が一番高かったですか',
      '普段料理はしますか',
      '学生のころ部活は何をしていましたか',
      'どこでも住めるならどこに住みたいですか',
      '普段どんな曲を聞いていますか',
      'ご飯派ですか、パン派ですか',
      '明日死ぬとしたら、最後に何を食べたいですか',
      '皆さんの誕生日はいつですか',
      'タイムトラベルできるなら、過去と未来どちらにいきたいですか',
      'コーヒー派ですか、紅茶派ですか',
      '今一番欲しいものは何ですか',
      '小さい時の夢はなんですか',
      '好きなお鍋の種類は何ですか',
      '好きなおにぎりの具は何ですか',
      'iPhone派ですか、Android派ですか',
      '動物園派ですか、水族館派ですか',
      '家ではメガネをかけてますか',
      'どのSNSが一番好きですか',
      '兄弟はいますか',
      '最近買った一番高いものは何ですか',
      '今までに一番ハマったゲームは何ですか',
      'モンチッチー、モンチッチー、モンチッチッのチー',
      'ペットを飼っていますか',
      '好きな果物ランキングを教えてください。',
      'アルバイトしてましたか',
      '最近一番ちからを入れていることは何ですか',
      '春夏秋冬どれが好きですか',
      '普段は何時ごろに寝ますか',
      'ラーメンは何味が好きですか',
      'QRコード決済は何を使っていますか',
      '今日一番幸せを感じたタイミングはいつですか',
      'もしあなたが学校の先生ならどの教科を教えますか',
      'どんな飲み物が好きですか',
      '一番好きな映画はなんですか',
      'ニックネームはありますか',
      '出身地で一番好きなところはどこですか',
      '寝るときはどんな服装ですか',
      '一番好きな色は何ですか',
      '海と山どっちが好きですか',
      '学生生活でハマっていたことはなんですか',
      '皆さんの出身はどこですか',
      '車の免許は持っていますか',
      '宇宙人はいると思いますか',
      '無人島に１つだけ持っていけるなら何を持っていきますか',
      '「都会」と「田舎」どっちに住みたい？',
      '最近何で泣きましたか',
      'アウトドア派ですか、インドア派ですか',
      '好きな異性の髪型とかありますか',
      '好きなYoutuberは誰ですか',
      '好きなテレビ番組は何ですか',
      'ゆで卵の固さはどれくらいが好きですか',
    ];
    const shuffledTopics = _.shuffle(topics);
    const startTimeMs = Date.now();
    // eslint-disable-next-line no-undef
    const MySpeechRecognition = webkitSpeechRecognition || SpeechRecognition;
    this.recognition = new MySpeechRecognition();
    this.recognition.lang = 'ja-JP';
    let silenceCountTimerId: number;
    let isReaction = false;
    let isFinalTopic = false;
    let isSpeaking = false;
    let is10Finished = false;
    let is30Finished = false;

    const startSilenceCount = () => {
      silenceCountTimerId = setTimeout(() => {
        isSpeaking = true;
        if (this.recognition) this.recognition.stop();
      }, 7000);
    };
    const stopSilenceCount = () => {
      clearTimeout(silenceCountTimerId);
    };
    this.recognition.addEventListener('soundstart', stopSilenceCount);
    this.recognition.addEventListener('soundend', startSilenceCount);
    this.recognition.addEventListener('result', () => {
      isReaction = true;
    });
    this.recognition.addEventListener('end', () => {
      if (isFinalTopic) return;
      if (!this.isRestart) {
        clearTimeout(silenceCountTimerId);
        if (this.recognition) this.recognition.removeEventListener('soundstart', stopSilenceCount);
        if (this.recognition) this.recognition.removeEventListener('soundend', startSilenceCount);
        return;
      }
      if (isSpeaking) {
        if (!isReaction) {
          if (this.recognition) this.recognition.start();
          return;
        }
        const newTopic = shuffledTopics.pop();
        const defaultTopic = 'すいません、新しい話題が思いつきません。';
        const utterance = new SpeechSynthesisUtterance(newTopic || defaultTopic);
        utterance.lang = 'ja-JP';
        utterance.onend = () => {
          if (!this.isRestart) return;
          if (this.recognition) this.recognition.start();
        };
        const passedTimeM = Math.round((Date.now() - startTimeMs) / 1000 / 60);
        const userSetTalkTimeM = Number(this.talkTime.H) * 60 + Number(this.talkTime.mm);
        const leftTimeM = userSetTalkTimeM - passedTimeM;
        if (leftTimeM < 0) {
          utterance.text = `予定より${-leftTimeM}分過ぎてるので、そろそろ終わりにしませんか？`;
        } else if (leftTimeM < 10 && !is10Finished) {
          utterance.text = `あと${leftTimeM}分で終了時間です。この会話にくわえていただきありがとうございます。また今度みんなで話すときは、私も混ぜていただけると嬉しいです！`;
          is10Finished = true;
          is30Finished = true;
        } else if (leftTimeM < 30 && !is30Finished) {
          utterance.text = `あと${leftTimeM}分で終了時間です。残りの時間も全力で話題をふりますので、どうぞよろしくお願い致します！`;
          is30Finished = true;
        }
        this.poppedTopic = utterance.text;
        speechSynthesis.speak(utterance);
        isReaction = false;
        if (newTopic === undefined) isFinalTopic = true;
      } else if (this.recognition) this.recognition.start();
      isSpeaking = false;
    });
    this.recognition.start();
  },
  beforeDestroy() {
    this.isRestart = false;
    if (this.recognition) this.recognition.stop();
  },
  methods: {
    endTalk() {
      this.$router.push('/');
    },
  },
});
